export default "__VITE_ASSET__9GyRhWhb__"